import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrinter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 41,
	viewBox: "0 0 41 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 18.0003V12.167H25.5V18.0003",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5003 25.5H13.8337C13.3916 25.5 12.9677 25.3244 12.6551 25.0118C12.3426 24.6993 12.167 24.2754 12.167 23.8333V19.6667C12.167 19.2246 12.3426 18.8007 12.6551 18.4882C12.9677 18.1756 13.3916 18 13.8337 18H27.167C27.609 18 28.0329 18.1756 28.3455 18.4882C28.6581 18.8007 28.8337 19.2246 28.8337 19.6667V23.8333C28.8337 24.2754 28.6581 24.6993 28.3455 25.0118C28.0329 25.3244 27.609 25.5 27.167 25.5H25.5003",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 22.167H15.5V28.8337H25.5V22.167Z",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPrinter;
